<template>
  <div>
    <el-upload
      class="single-image-uploader"
      :multiple="true"
      :file-list="fileList"
      list-type="picture-card"
      :on-preview="handlePreview"
      :action="uploadQiniuDomain"
      :before-upload="beforeUpload"
      :data="dataObj"
      accept="image/*,.doc,.docx,.jpg"
      :on-success="handleSuccess"
      :on-remove="handleRemove">
      <i class="el-icon-plus"></i>
    </el-upload>

    <fw-image-modal v-model="dialogVisible" :url="dialogImageUrl" :fileUrl="dialogFileUrl" @save="save"></fw-image-modal>
  </div>
</template>

<script>
// can upload all file types
import uploadMixin from '@/mixins/uploadMixin'

import FwImageModal from '@/components/Common/FwImageModal.vue'
import _ from 'lodash'

export default {
  name: 'FwFileUpload',
  mixins: [uploadMixin],
  components: {
    FwImageModal
  },
  data () {
    return {
      dialogImageUrl: '',
      dialogFileUrl: '',
      dialogVisible: false,
      activeIndex: 0,
      fileList: []
    }
  },
  methods: {
    emitInput (fileList) {
      this.$emit('input', fileList.map(img => img.qiniuKey))
    },
    handleRemove (file, fileList) {
      this.emitInput(fileList)
    },
    handleSuccess (resp, file, fileList) {
      file.url = this.checkImgUrl(resp.key)
      file.qiniuKey = resp.key
      this.emitInput(fileList)
    },
    handlePreview (file) {
      this.dialogImageUrl = this.getFilePreviewPath(file.qiniuKey)
      this.dialogFileUrl = `${this.qiniuHost}${file.qiniuKey}`
      this.dialogVisible = true
      this.activeIndex = file.index
    },
    checkImgUrl (url) {
      const qiniuUrl = 'https://qn.feijing88.com/'
      if (_.includes(url, qiniuUrl)) {
        return url
      } else {
        return `${qiniuUrl}${url}`
      }
    },
    save (url) {
      this.$emit('save', { url, index: this.activeIndex })
    }
  },
  mounted () {
    return this.getQiniuToken().then(() => {
      if (this.value) {
        this.fileList = this.transformValue(this.value)
        this.emitInput(this.fileList)
      }
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Common/FwFileUpload.vue